/**
 * Back to top function.
 *
 * It is working with php file /template-parts/components/back-to-top.php
 */
const backToTop = document.querySelector('.back-to-top');

window.addEventListener('scroll', () => {
    if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
        backToTop.style.opacity = 1;
    } else {
        backToTop.style.opacity = 0;
    }

    backToTop.addEventListener('click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

});

/**
 * Smooth scroll for every link which has #back-to-top in href
 */
document.querySelectorAll('a[href="#back-to-top"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        this.setAttribute('href', '');

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });
});
